import React from 'react';

import StatusSummaryButton from '../../../status/statusSummaryButton.jsx';
import partnerPropTypes from '../../../partnerPropTypes.js';
import { data as paymentDataPropTypes } from '../../../paymentPropTypes.js';
import withdrawalPropTypes from '../../../withdrawalPropTypes.js';
import formatOreToKroner from '../../../../lib/formatOreToKroner.js';

function getDiscountInformationAsSentence({ partner, payment }) {
    switch (payment.performedBy) {
        case 'SELLER':
            return `${partner.name} har godtatt et prisavslag på ${formatOreToKroner(
                payment.discount
            )}.`;
        default:
            return `Du har godtatt et prisavslag på ${formatOreToKroner(
                payment.discount
            )}.`;
    }
}

const DiscountApprovedSummary = ({ partner, payment, withdrawal }) => {
    let actionRequiredType;
    let body;
    let statusSummary;

    if (withdrawal) {
        body = getDiscountInformationAsSentence({ partner, payment });
        statusSummary = 'Handelen er ferdig';
    } else {
        actionRequiredType = 'POSITIVE';
        body = 'Få tilbake pengene';
        statusSummary = getDiscountInformationAsSentence({ partner, payment });
    }

    return (
        <StatusSummaryButton
            actionRequiredType={actionRequiredType}
            href="/losning/enighet-om-avslag"
            statusSummary={statusSummary}
        >
            {body}
        </StatusSummaryButton>
    );
};

DiscountApprovedSummary.propTypes = {
    partner: partnerPropTypes.isRequired,
    payment: paymentDataPropTypes.isRequired,
    withdrawal: withdrawalPropTypes,
};

export default DiscountApprovedSummary;



// WEBPACK FOOTER //
// ./safeTrade/buyer/resolution/summaries/discountApprovedSummary.jsx